<app-notification></app-notification>
<div id="bg">
  <img src="/assets/images/login-background.png" alt="" />
  <div class="centered">
    <div class="card" *ngIf="CurrentState == 'NotVerified'">
      <div class="login">Reset Password</div>
      <div class="col-md-12">
        <div class="url-hint">
          <mat-hint
            ><h1>URL EXPIRED</h1>
            THE LINK YOU FOLLOWED HAS EXPIRED PLEASE TRY ANOTHER !</mat-hint
          >
        </div>
      </div>
    </div>
    <div class="card" *ngIf="CurrentState == 'Verified'">
      <div class="login">Reset Password</div>
      <form [formGroup]="ResetForm" (ngSubmit)="onSubmit()">
        <!--UserID-->

        <mat-form-field class="log">
          <mat-label>New Password</mat-label>
          <input
            matInput
            placeholder="New Password"
            [type]="show ? 'text' : 'password'"
            formControlName="password"
            required
            (keydown)="onChange()"
          />
          <mat-icon matSuffix class="icon" (click)="toggleShow()">{{
            show ? "visibility" : "visibility_off"
          }}</mat-icon>
        </mat-form-field>
        <mat-form-field class="log">
          <mat-label>Confirm Password</mat-label>
          <input
            matInput
            placeholder="Confirm Password"
            [type]="showConfirm ? 'text' : 'password'"
            formControlName="confirmPassword"
            required
            (keydown)="onChange()"
          />
          <mat-icon matSuffix class="icon" (click)="toggleConfirmShow()">{{
            show ? "visibility" : "visibility_off"
          }}</mat-icon>
        </mat-form-field>
        <!--Submit-->
        <button mat-flat-button color="primary" class="submit">SUBMIT</button>
        <div class="hint">
          <mat-hint *ngIf="hint !== ''">{{ hint }}</mat-hint>
        </div>
        <mat-error *ngIf="error !== ''" class="error">{{ error }}</mat-error>
      </form>
    </div>
  </div>
</div>
